import { createFileRoute, useParams } from "@tanstack/react-router"
import { checkPermissions } from "@/utils/checkPermissions"
import { useStudentProgressOverviewQuery } from "@/api/queries/students/useStudentProgressOverviewQuery"
import { Button, StudentProgressDetailPage } from "toptaal-shared"
import { useStudentSuspenseQuery } from "@/api/queries/students/useStudentSuspenseQuery"
import { useStudentCurrentInterruptionQuery } from "@/api/queries/students/useStudentCurrentInterruptionQuery"
import { useState } from "react"
import { RemoveStudentFromGroupModal } from "@/components/modals/group/RemoveStudentFromGroupModal"

export const Route = createFileRoute("/beheer/cursisten/$studentId/voortgang/")(
  {
    component: RouteComponent,
    beforeLoad: () => checkPermissions("read", "students"),
  },
)

function RouteComponent() {
  const { studentId } = useParams({
    from: "/beheer/cursisten/$studentId/voortgang/",
  })
  const { data } = useStudentProgressOverviewQuery(Number(studentId))
  const {
    data: { data: student },
  } = useStudentSuspenseQuery(Number(studentId))
  const groups = data?.data.groups ?? []
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { data: currentInterruption } = useStudentCurrentInterruptionQuery(
    student.currentStudentProjectOrganization?.id,
  )

  return (
    <>
      <StudentProgressDetailPage
        groups={groups}
        historical={data?.data.historical}
        status={student.currentStudentProjectOrganization?.status}
        moduleCode={student.currentModule?.moduleCode}
        interruption={currentInterruption}
        actionButton={
          student.currentStudentProjectOrganization?.status !==
          "dropped_out" ? (
            <Button variant="primary" onClick={() => setIsModalOpen(true)}>
              Wijziging doorgeven
            </Button>
          ) : undefined
        }
      />

      {isModalOpen && (
        <RemoveStudentFromGroupModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          studentId={Number(studentId)}
        />
      )}
    </>
  )
}
